import {defineMessages} from 'react-intl'

export const australiaStateMessages = defineMessages({
    'state.au.australiancapitalterritory': {
        id: 'state.au.australiancapitalterritory',
        defaultMessage: 'Australian Capital Territory'
    },
    'state.au.newsouthwales': {
        id: 'state.au.newsouthwales',
        defaultMessage: 'New South Wales'
    },
    'state.au.northernterritory': {
        id: 'state.au.northernterritory',
        defaultMessage: 'Northern Territory'
    },
    'state.au.queensland': {
        id: 'state.au.queensland',
        defaultMessage: 'Queensland'
    },
    'state.au.southaustralia': {
        id: 'state.au.southaustralia',
        defaultMessage: 'South Australia'
    },
    'state.au.tasmania': {
        id: 'state.au.tasmania',
        defaultMessage: 'Tasmania'
    },
    'state.au.victoria': {
        id: 'state.au.victoria',
        defaultMessage: 'Victoria'
    },
    'state.au.westernaustralia': {
        id: 'state.au.westernaustralia',
        defaultMessage: 'Western Australia'
    }
})

export const australiaStateOptions = [
    {value: 'ACT', label: 'state.au.australiancapitalterritory'},
    {value: 'NSW', label: 'state.au.newsouthwales'},
    {value: 'NT', label: 'state.au.northernterritory'},
    {value: 'QLD', label: 'state.au.queensland'},
    {value: 'SA', label: 'state.au.southaustralia'},
    {value: 'TAS', label: 'state.au.tasmania'},
    {value: 'VIC', label: 'state.au.victoria'},
    {value: 'WA', label: 'state.au.westernaustralia'}
]
